import {
  lastDayOfMonth,
  lastDayOfQuarter,
  lastDayOfWeek,
  lastDayOfYear,
  startOfMonth,
  startOfQuarter,
  startOfToday,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
} from 'date-fns';
import LangEnum from '../../../../lang/LangEnum';
import { DateShortcut, DateShortcutRange } from './dateRangeFilter.types';

export const getDateShortcuts = (): DateShortcutRange[] => {
  const referenceDate = startOfToday();
  return [
    {
      name: DateShortcut.DAY,
      title: LangEnum.GLOBAL_DATE_TODAY,
      finalDate: referenceDate,
      initialDate: referenceDate,
    },
    {
      name: DateShortcut.WEEK,
      title: LangEnum.GLOBAL_DATE_CURRENT_WEEK,
      finalDate: lastDayOfWeek(referenceDate),
      initialDate: startOfWeek(referenceDate, { weekStartsOn: 0 }),
    },
    {
      name: DateShortcut.MONTH,
      title: LangEnum.GLOBAL_DATE_CURRENT_MONTH,
      finalDate: lastDayOfMonth(referenceDate),
      initialDate: startOfMonth(referenceDate),
    },
    {
      name: DateShortcut.QUARTER,
      title: LangEnum.GLOBAL_DATE_CURRENT_QUARTER,
      finalDate: lastDayOfQuarter(referenceDate),
      initialDate: startOfQuarter(referenceDate),
    },
    {
      name: DateShortcut.YEAR,
      title: LangEnum.GLOBAL_DATE_CURRENT_YEAR,
      finalDate: lastDayOfYear(referenceDate),
      initialDate: startOfYear(referenceDate),
    },
    {
      name: DateShortcut.SEVEN_DAYS,
      title: LangEnum.GLOBAL_DATE_LAST_SEVEN_DAYS,
      finalDate: referenceDate,
      initialDate: subDays(referenceDate, 6),
    },
    {
      name: DateShortcut.THIRTY_DAYS,
      title: LangEnum.GLOBAL_DATE_LAST_THIRTY_DAYS,
      finalDate: referenceDate,
      initialDate: subDays(referenceDate, 29),
    },
    {
      name: DateShortcut.SIXTY_DAYS,
      title: LangEnum.GLOBAL_DATE_LAST_SIXTY_DAYS,
      finalDate: referenceDate,
      initialDate: subDays(referenceDate, 59),
    },
    {
      name: DateShortcut.NINETY_DAYS,
      title: LangEnum.GLOBAL_DATE_LAST_NINETY_DAYS,
      finalDate: referenceDate,
      initialDate: subDays(referenceDate, 89),
    },
    {
      name: DateShortcut.TWELVE_MONTHS,
      title: LangEnum.GLOBAL_DATE_LAST_TWELVE_MONTHS,
      finalDate: referenceDate,
      initialDate: subMonths(referenceDate, 12),
    },
    {
      name: DateShortcut.ALL_PERIOD,
      title: LangEnum.GLOBAL_DATE_ALL_PERIOD,
      finalDate: null,
      initialDate: null,
    },
  ];
};
